/**
 * @file: arcUtil.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

export function pathOfArc(
  cx: number,
  cy: number,
  r: number,
  startAngle: number,
  endAngle: number,
  largeArcFlag: boolean,
  clockwise: boolean,
) {
  'worklet';

  const { x: x1, y: y1 } = angleXY(cx, cy, r, startAngle);
  const { x: x2, y: y2 } = angleXY(cx, cy, r, endAngle);

  const d = [
    'M',
    x1,
    y1,
    'A',
    r /* rx */,
    r /* ry */,
    0 /* rotation */,
    largeArcFlag ? 1 : 0 /* largeArcFlag */,
    clockwise ? 1 : 0 /* clock wise */,
    x2,
    y2,
  ].join(' ');

  return d;
}

// note: angle start from north clockwise.
export function angleXY(cx: number, cy: number, r: number, angle: number) {
  'worklet';
  const angleInRadians = ((angle - 90) * Math.PI) / 180.0;
  return {
    x: cx + r * Math.cos(angleInRadians),
    y: cy + r * Math.sin(angleInRadians),
  };
}
